import script from "./EmailVerificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerificationModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerificationModal.vue?vue&type=style&index=0&id=733606aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733606aa"]])

export default __exports__